import Joi from "joi";
import errorsResolver from "../schemeUtils";

const accepted = {
  CREDIT: 'Принято от',
  DEBIT: 'Выдать'
}
export const createTransactionEditScheme = (type) => {
  Joi.object({
    documentNumber: Joi.number()
      .required().empty('')
      .max(999999999)
      .min(0)
      .integer()
      .error(errorsResolver({
        numberUnsafe: `Номер документа должен быть корректным числом`,
        numberMin: `Номер документа должен больше нуля`,
        numberMax: `Номер документа должен быть меньше 99999999.99`,
        number: `Номер документа должен быть числом`,
        required: `Номер документа обязательное поле`,
        numberBase: `Номер документа должен быть числом`
      })),
    accepted:
      Joi.object({
        label:
          Joi.string()
            .required('')
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-., ]*$'))
            .error(errorsResolver({
              required: `${accepted[type]} обязательное поле`,
              pattern: `Поле содержит некорректные символы`
            })),
        value:
          Joi.number()
            .error(errorsResolver({
              number: `Должно быть число`
            }))
      })
        .invalid(null)
        .required()
        .error(errorsResolver({
          invalid: `${accepted[type]} обязательное поле`,
          required: `${accepted[type]} обязательное поле`,
          objectBase: `${accepted[type]} обязательное поле`
        })),
    description: Joi.string()
      .max(200)
      .allow('')
      .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-.,№*()/\\\\ \n]*$'))
      .error(errorsResolver({
        max: `Приложение должно быть до 200 символов`,
        required: `Приложение обязательное поле`,
        pattern: `Приложение содержит некорректные символы`
      })),
    attachment: Joi.string()
      .max(200)
      .allow('')
      .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-.,№:()/\\\\ ]*$'))
      .error(errorsResolver({
        max: `Дополнительная информация должна быть до 200 символов`,
        required: `Дополнительная информация обязательное поле`,
        pattern: `Дополнительная информация содержит некорректные символы`
      })),
    passport: Joi.string()
      .max(200)
      .allow('')
      .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ\\-.,;0-9 ]*$'))
      .error(errorsResolver({
        max: `Паспортные данные должны быть до 200 символов`,
        required: `Паспортные данные обязательное поле`,
        pattern: `Паспортные данные содержит некорректные символы`
      })),
    toPerson: Joi.bool()
  });}

